import TitleBg from "../../images/pricing/titlebg.svg";
import InstagramIcon from "../../images/logo/instagram.png";
import WhatsAppIcon from "../../images/logo/whatsapp.png";
import MainButton from "../MainButton";

function Hero() {
  return (
    <>
      <section
        id="home"
        className="hero-section w-full h-screen min800:flex min800:justify-center min800:text-center"
      >
        <div className="container-hero">
          {/* hero section */}
          <div
            className="flex flex-col text-white items-center text-center 
           absolute hero-text left-1/2 -translate-x-1/2 w-[90%]"
          >
            <div className="relative flex items-center justify-center mb-8 px-12">
              <img
                src={TitleBg}
                alt="text_bg"
                className="w-full absolute title-white"
              />
              <p className="text-black text-[18px] desk:text-[14px] uppercase font-medium relative z-10 whitespace-nowrap">
                find your energy
              </p>
            </div>
            <h1 className="font-bold text-[48px] desk:text-[38px] uppercase mb-[4rem]">
              make your body <br />
              <span className="font-thin">fit & perfect</span>
            </h1>

            <MainButton
              color={`text-black`}
              bg={`bg-white`}
              text="enquire now"
              goTo="/contact"
            />
          </div>
        </div>
        {/* socials */}
        <div
          className="flex flex-row-reverse -rotate-90 text-white
          absolute top-2/4 right-0 items-center min800:hidden"
        >
          <p className="uppercase  text-3xl font-bold tracking-widest">share</p>
          <span className="w-[35px] bg-[#FF0336] h-[2.5px] mr-6"></span>
          <div className="text-white gap-7 flex mr-7 ">
            <a
              href="https://www.instagram.com/akfitnessjbp/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={InstagramIcon}
                alt="instagram"
                className="w-[3rem] h-[3rem] object-contain cursor-pointer rotate-90"
              />
            </a>
            <a
              href="https://wa.me/919406761177"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={WhatsAppIcon}
                alt="whatsapp"
                className="w-[3rem] h-[3rem] object-contain cursor-pointer rotate-90"
              />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
